/* eslint-disable import/no-anonymous-default-export */
import { AxiosError } from "axios";
import useApi, { ActionResult, Api, Model, Query } from "../common/hooks/useApi"
import { TipoExportacion } from "../configuraciones-produccion/useConfiguracionesProduccionAPI";

export interface LoteExportacion extends Model
{
    NroLote:string
    FechaHora:string
    UrlLoteComprimido?:string
    TipoExportacion:TipoExportacion
    CodigoProveedorBA:string
    AutoridadConstatacionBA:string
    CodigoJurisdiccionBA:string
    CodigoPostalBA:string
    ExportacionBA?: {
        FullUrl:string
    }
}

const module = "LoteExportacion";

export default ()  => {
    const api = useApi({module});
    
    return {
        list:(query:Query)=>api.list!<LoteExportacion>(query),
        save:(data:Partial<LoteExportacion>)=>api.save!<Partial<LoteExportacion>,LoteExportacion>(data),
        delete:(id:number)=>api.delete(id),
        generateLoteActa: async (query: Query, tipo:TipoExportacion): Promise<ActionResult<string | string[]>>=> {
            try {
                let qs = api.queryToString(query);
                const response = await api.axiosInstance.post<string | string[]>(`${module}/Generar?tipo=${tipo}&${qs}`);
                return {
                    data: {
                        value:response.data
                    }
                };
            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        },
    };
}